export const applyStylesIf = (
	condition: boolean,
	styles: string
): string | false => condition && styles
